<template>
  <div class="pic_box">
    <div v-for="(item,index) in pic_list" :key="index" class="pic_item">
      <el-image
        fit="contain"
        :src="item.url"
        :style="{
          border:item.checked?'2px solid #2096f5':'none'
        }"
        @click="chosePic(item)"
      />
      <div class="img-func">
        <el-button
          icon="el-icon-zoom-in"
          circle
          @click.stop="openViewer(index)"
        />
      </div>
    </div>
    <div v-if="show_viewer" ref="viewer_box" class="viewer_box">
      <p class="viewer_tips">当前为第{{ show_viewer_index + 1 }}张图片</p>
      <el-button class="chose_btn" @click.stop="choseViewerPic(show_viewer_index)">
        {{
          pic_list[show_viewer_index].checked?'取消选中':'选中'
        }}
      </el-button>
    </div>
    <el-image-viewer
      v-if="show_viewer"
      :z-index="3000"
      :on-close="closeViewer"
      :on-switch="switchViewer"
      :initial-index="show_viewer_index"
      :url-list="picList"
    />
  </div>
</template>

<script>

export default {
  components: {
    'el-image-viewer': () =>
      import('element-ui/packages/image/src/image-viewer'),
  },
  props: {
    // 图片数组
    picList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      pic_list: [],
      show_viewer: false,
      show_viewer_index: '', // 当前显示图片下标
      checked_list: [], // 选中图片数组
    };
  },

  created(){
    // 增加是否选择状态参数
    this.pic_list = this.picList.map(item => {
      const obj = {
        url: item,
        checked: false,
      };
      return obj;
    });
  },

  methods: {
    /**
      * 选中截图
      * @param item 当前选中图片的数据
     */
    chosePic(item){
      item.checked = !item.checked;
      // 选中
      if (item.checked){
        this.checked_list.push(item.url);
      } else {
        this.checked_list = this.checked_list.filter(e => {
          return e !== item.url;
        });
      }
      this.$emit('checked', this.checked_list);
    },

    /**
      * 点击预览放大图片
      * @param index 当前预览图片的下标
     */
    openViewer(index){
      const body = document.querySelector('body');
      this.show_viewer = true;
      this.show_viewer_index = index;
      this.$nextTick(() => {
        if (body.append) {
          body.append(this.$refs.viewer_box);
        } else {
          body.appendChild(this.$refs.viewer_box);
        }
      });
    },

    /**
      * 切换预览图片
      * @param index 当前预览图片的下标
     */
    switchViewer(index){
      this.show_viewer_index = index;
    },

    /**
      * 点击按钮选中截图
      * @param i 当前选中图片的下标
     */
    choseViewerPic(i){
      const item = this.pic_list.find((item, index) => {
        return index === i;
      });
      this.chosePic(item);
    },

    // 关闭预览图片
    closeViewer() {
      this.show_viewer = false;
    },

  },
};
</script>

<style  scoped rel="stylesheet/scss" lang="scss">
.pic_box{
  width: 100%;
  height: 385px;
  margin-top: 10px;
  overflow: auto;
  .pic_item{
    width: 25%;
    height: 230px;
    float: left;
    padding: 10px;
    position: relative;
    margin-bottom: 25px;
    .el-image{
      width: 100%;
      height: 100%;
      margin: 0 auto;
      top: 50%;
      transform: translateY(-50%);
    }
    .img-func {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 36px;
      height: 36px;
      margin: auto;
      z-index: 1;
      &:hover {
        transform: scale(1.2);
      }
    }
    .el-icon-success{
      float: left;
      z-index: 10;
      font-size: 16px;
    }
  }
}
</style>
